import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloat from "../DynamicDTFloat";
import DropDownControl from "../DropDownControl";
import { BeatLoader } from "react-spinners";
import { hst03_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen } from "../../utils";
import ProcessLoader from "../ProcessLoader";
import configData from "../../config.json";


const HST03 = () => {

    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const allIndiaTypeDepo = depo_data.data.filter(item => item.value !== "NA"); //removed 0 from all type users
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDepo, setSelectedDepo] = useState(allIndiaTypeDepo[0].value);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[0].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [creditNoteType, setCreditNoteType] = useState(0);

    const [ReportType, setReportType] = useState(1);
    const [showProcessLoader, setShowProcessLoader] = useState(false);

    const [pageTitle, setPageTitle] = useState('');
    const handleExportSheet = async () => {

        var reportJson = {};
        reportJson.fileName = reportGenData.title + ".xlsx";
        reportJson.title = reportGenData.title;
        reportJson.author = "Aristo Pharma";

        reportJson.sheets = [
            {
                name: "Sheet 1",
                data: []
            }
        ]

        const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
        const headerFormatted = columns.map(key => getHeaderColNames(key));

        reportJson.sheets[0].data.push({
            backgroundColor: "#0043a9",
            fontColor: "#FFFFFF",
            fontSize: 13,
            bold: true,
            values: headerFormatted
        });

        const backgroundColors = excelColorCodes;

        reportGenData.data.forEach(item => {
            const row = {
                backgroundColor: backgroundColors[item.color] || "",
                fontColor: item.color === 2 ? "#333333" : "#333333",
                fontSize: 12,
                bold: false,
                values: columns.map(col => item[col])
            };
            reportJson.sheets[0].data.push(row);
        });

        generateExcel(reportJson).catch(console.error);

    }

    const handleReportGen = async () => {

        setShowProcessLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";
        goFullScreen();
        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "rep_type": parseInt(ReportType),
            "credit_note_type": parseInt(creditNoteType)

        }

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/stkrepo3`, payload, "get");


        const new_data = hst03_report_json_format(reportAPIResponse);
        console.log(new_data);
        setreportGenData(new_data);
        setShowOptions(false);
        setShowProcessLoader(false);
    }

    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);


    }

    useEffect(() => {
        transformNavDataForLabels("ST03").then(title => {
            setPageTitle(title);
        });


    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                {showOptions ?
                    <ReportOptions title={pageTitle} >
                        <div className="report-option-wrapper">
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Division</label>
                                    <DropDownControl data={div_data.data} id="report_div_list" selectedValue={SelectedDiv} name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); }} />
                                </div>
                            </div>
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label className="mr-16">Branch</label>
                                    <DropDownControl data={allIndiaTypeDepo} id="report_branch_list" name="report_branch_list"

                                        onChange={handleBranchChange}
                                    />
                                </div>


                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label className="mr-30">From</label>
                                    <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                                </div>
                                <div className="report-option-item ml-10">
                                    <label>To</label>
                                    <DropDownControl data={month_data.data} id="report_endyear_list" name="report_endyear_list" selectedValue={SelectedEndMonth} onChange={(val) => { console.log(val); setSelectedEndMonth(val) }} />
                                </div>
                                <div className="report-option-item ml-20">
                                    <label>Mkt&nbsp;Year</label>
                                    <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => { console.log(newYear); setSelectedYear(newYear) }} />

                                </div>
                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 1)}
                                        onChange={(e) => { setReportType(1);; }} />
                                    <label>Gross</label>
                                </div>
                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 2)}
                                        onChange={(e) => { setReportType(2); setCreditNoteType(0); }} />
                                    <label>Credit</label>
                                </div>

                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 3)}
                                        onChange={(e) => { setReportType(3); }} />
                                    <label>Net</label>
                                </div>


                                {
                                    ReportType == 2 && <div className="report-option-item ml-20">
                                        <label>Credit&nbsp;Note</label>
                                        <DropDownControl data={configData.credit_note_dd} selectedValue={creditNoteType} name="creditNoteType" id="creditNoteType" onChange={(val) => { setCreditNoteType(val) }} />
                                    </div>
                                }

                            </div>




                            <div className="report-option-action-row">
                                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                                <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                            </div>
                        </div>
                    </ReportOptions>
                    :
                    <>
                        <div className="row">
                            <div className="col-12">
                                <div className="card report-card" style={{ width: "auto" }}>
                                    <div className="card-title report-card-title">{reportGenData.title}
                                        <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                    </div>
                                    <div className="card-body">
                                        <DynamicDTFloat
                                            tableData={reportGenData}
                                            firstColWidth="280px"
                                            secColWidth="auto"
                                            handleExportSheet={handleExportSheet}
                                            fixedColumns={true}
                                            forceDecimal={reportGenData.decimal_keys?.length > 0}
                                            decimalKeys={reportGenData.decimal_keys}
                                        />

                                    </div>
                                    <div className="card-footer">

                                        <button className="btn btn-outline btn-primary text-white btn-sm float-right"
                                            onClick={handleExportSheet}
                                        >Export Excel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }


            </div>
        </>

    );
}

export default HST03;


